import { BrandInfo } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageFilmStripBrandList/__internal__/FilmstripBrandList/__internal__/BrandInfo";
import { ProductsCarousel } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageFilmStripBrandList/__internal__/FilmstripBrandList/__internal__/ProductsCarousel";
import { Flex, HorizontalLine } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { ISearchBrandsV2Response } from "@faire/web-api--source/indigofair/data/ISearchBrandsV2Response";
import React from "react";
import styled from "styled-components";

interface IProps {
  brands: ISearchBrandsV2Response.IBrand[] | undefined;
  categoryPathIdentifier: string;
  loadTimingRef?: React.Ref<HTMLDivElement>;
}

export const FilmstripBrandList: React.FC<IProps> = ({
  brands,
  categoryPathIdentifier,
  loadTimingRef,
}) => {
  const { isTabletAndAbove } = useViewport();
  if (!brands?.length) {
    return null;
  }
  return (
    <div ref={loadTimingRef}>
      {brands.map((brand, index) => (
        <React.Fragment key={`${brand?.token}`}>
          <FilmstripBrandTile
            brand={brand}
            categoryPathIdentifier={categoryPathIdentifier}
          />
          {index !== brands.length - 1 && isTabletAndAbove ? (
            <HorizontalLine />
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
};

const FilmstripBrandTile: React.FC<{
  brand: ISearchBrandsV2Response.IBrand;
  categoryPathIdentifier: string;
}> = ({ brand, categoryPathIdentifier }) => {
  return (
    <Container direction={{ mobileAndAbove: "column", tabletAndAbove: "row" }}>
      <BrandInfo
        brand={brand}
        categoryPathIdentifier={categoryPathIdentifier}
      />
      <StyledProductsCarousel
        brand={brand}
        categoryPathIdentifier={categoryPathIdentifier}
      />
    </Container>
  );
};

const Container = styled(Flex)`
  padding: ${getSpacing("3x", 0)};

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("6x", 0)};
  }
`;

const StyledProductsCarousel = styled(ProductsCarousel)`
  ${responsiveMediaQueries.mobile} {
    // to offset HorizontalScrollCarousel left/right padding
    padding: ${getSpacing("2x", 0)};
    margin-left: -20px;
    margin-right: -16px;
    width: auto;
  }
`;
